import * as React from 'react';

import Button from '@/components/elements/Button/BaseButton';
import TrashButton from '@/components/elements/Button/TrashButton';
import Counter from '@/components/elements/Form/Counter';
import CompositeOdds from '@/components/elements/Text/CompositeOdds';
import OddsRange from '@/components/elements/Text/OddsRange';
import SetNumber from '@/components/elements/Text/SetNumber';
import RefundRange from '@/components/layouts/Modal/BetPanel/Partials/TicketBox/Singlerace/Pertials/RefundRange';
import { BetDetail, OddsData, Ticket } from '@/modelTypes';

import { ButtonWrapper } from '../../style';
import {
  Detail,
  DetailWrapper,
  PromisingBetInfo,
  SetNumberArea,
} from './style';

interface ReadyProps {
  betDetail: BetDetail;
  oddsData: OddsData;
  hashKey: string;
  changeCount: (
    value: number,
    itemId: string,
    setNum?: number | undefined,
  ) => void;
  deleteTicket: (itemId: string, setNum?: number | undefined) => void;
  setOpenList: React.Dispatch<React.SetStateAction<string[]>>;
}

const Ready: React.FC<ReadyProps> = ({
  betDetail,
  oddsData,
  hashKey,
  changeCount,
  deleteTicket,
  setOpenList,
}) => {
  const arrayOfSetNum = (tickets: Ticket[]) => tickets.map(t => t.setNum);

  return (
    <>
      <PromisingBetInfo>
        <SetNumberArea>
          <p>買い目</p>
          <SetNumber
            setNums={arrayOfSetNum(betDetail.tickets)}
            firstThreeRacerList={betDetail.firstThreeRacerList}
            betType={betDetail.betType}
          />
        </SetNumberArea>
        <ButtonWrapper>
          <Counter
            value={betDetail.tickets[0].count}
            min={1}
            max={999}
            disabled={betDetail.tickets[0].isRemoved}
            onChange={val => changeCount(val, hashKey)}
          />
          <TrashButton
            isRemoved={betDetail.tickets[0].isRemoved}
            onClick={() => deleteTicket(hashKey)}
          />
        </ButtonWrapper>
      </PromisingBetInfo>
      <DetailWrapper>
        <Detail>
          <p>オッズ</p>
          <OddsRange
            odds={oddsData.exists ? oddsData.data : null}
            setNums={arrayOfSetNum(betDetail.tickets)}
            betType={betDetail.betType}
          />
        </Detail>
        <Detail>
          <p>合成オッズ</p>
          <CompositeOdds
            odds={oddsData.exists ? oddsData.data : null}
            setNums={arrayOfSetNum(betDetail.tickets)}
            betType={betDetail.betType}
          />
        </Detail>
        <Detail>
          <p>想定払戻金額</p>
          <RefundRange
            setNums={arrayOfSetNum(betDetail.tickets)}
            betType={betDetail.betType}
            count={betDetail.tickets[0].count}
            odds={oddsData.exists ? oddsData.data : null}
          />
        </Detail>
      </DetailWrapper>
      {betDetail.tickets.length > 1 && (
        <Button
          size="xs"
          bgColor="secondary"
          fontWeight="bold"
          outline
          radius="s"
          height="36px"
          onClick={() => setOpenList(prev => [...prev, hashKey])}
        >
          買い目を展開する
        </Button>
      )}
    </>
  );
};

export default Ready;
